import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {AssortmentHeroCardStore, useVipLocalStore, VipLocalStore} from '@modules'
import {useAssortmentHeroCardStore} from '@modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/HeroCards/AssortmentHeroCard'
import {StoresInstance} from '@stores'
import {toJS} from 'mobx'
import {HeroCardSecondLevel} from './HeroCardSecondLevel'
import * as css from './HeroCardsSecondLevel.css'

/// region Store

export class HeroCardsSecondLevelStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'> & { heroCard: AssortmentHeroCardStore }) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    this.heroCard.secondLevel = this
    return () => {
      _toDispose.forEach(d => d())
    }
  }

  get heroCard() { return this.props.heroCard}

  get config() { return this.heroCard.config}
  get assortmentCard() { return this.heroCard.assortment}

  @computed get secondLevelItemsRaw() {
    const {props, heroCard, heroCard: {bomTree, bomItemResults}} = this
    return props.items ?? (_.isEmpty(bomTree) ? heroCard.data?.items : (bomItemResults ?? []))
  }

  @computed get secondLevelItems() {
    const {config: {child}, heroCard, heroCard: {hasBOMItems}, catalog, es: {getItemById}, secondLevelItemsRaw, stores} = this
    if (!child || !secondLevelItemsRaw) return []

    const {field, sort, bom} = child

    let items = secondLevelItemsRaw
    if (hasBOMItems) {
      if (bom.onlyIfField) {
        items = items.filter(v => _.get(v, bom.onlyIfField))
      }

      items = [...heroCard.data.items, ...items]
    }

    if (field) {
      items = _.flatMap(items.map(item => {
        return _.get(item, field)
      })).filter(_.identity)
    }

    try {
      return sort ? sort(items, stores) : items
    } catch (err) {
      console.error(err)
      return items
    }
  }
}

export const HeroCardsSecondLevelStoreContext = React.createContext<HeroCardsSecondLevelStore>(null)
export const useHeroCardsSecondLevelStore = () => React.useContext(HeroCardsSecondLevelStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  heroKey: string
  items?: Array<any>
}

export const HeroCardsSecondLevel = observer<MyProps, HTMLDivElement>(function HeroCardsSecondLevel({className, heroKey, ...props}, ref) {
  const heroCard = useAssortmentHeroCardStore(),
    obsProps = useAsObservableSource({heroKey, heroCard}),
    store = useVipLocalStore((stores) => new HeroCardsSecondLevelStore(stores, obsProps)),
    {secondLevelItems} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <HeroCardsSecondLevelStoreContext.Provider value={store}>
      <div ref={ref} className={classNames(css.root, className)}
           >
        <div className={css.cards}>
          {secondLevelItems.map((item, i) => <HeroCardSecondLevel key={i} index={i} item={item}/>)}
        </div>
      </div>
    </HeroCardsSecondLevelStoreContext.Provider>)
}, {forwardRef: true})
/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/HeroCards/HeroCardsSecondLevel.tsx